import { render } from "./ProductSelectorDialog.vue?vue&type=template&id=0003e862&scoped=true"
import script from "./ProductSelectorDialog.vue?vue&type=script&lang=js"
export * from "./ProductSelectorDialog.vue?vue&type=script&lang=js"

import "./ProductSelectorDialog.vue?vue&type=style&index=0&id=0003e862&lang=less&scoped=true"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0003e862"]])

export default __exports__